import { UserModel } from "app/models/UserModel";
import { isAcademyOnboardingCoach } from "app/utils/subscription";

/**
 * Figma 410:21980 (Academy-Onboarding): shown once to an Academy coach on
 * their first visit to /calendar. It replaced the retired "New Calendar
 * Views" announcement (removed 2026-09-10 with its calendar_views_popup_shown
 * flag); non-Academy users see no first-visit modal.
 *
 * Persisted by the BE as `calendar_settings_popup_shown` on the account,
 * read here as `calendarSettingsPopupShown` and set to true on dismiss via
 * PUT /account.
 */
export const shouldShowCalendarSettingsPopup = (
  self: UserModel | null | undefined,
): boolean => {
  if (!isAcademyOnboardingCoach(self)) {
    return false;
  }
  return !self.calendarSettingsPopupShown;
};
